<template>
  <div>
    <!-- Label -->
    <div
      v-if="placeholder"
      class="w-full pb-1 text-grey-darker font-semibold break-words"
    >
      <label :for="name">{{ placeholder }}</label>
      <span v-if="required" class="text-red">*</span>
    </div>

    <!-- Input Wrapper -->
    <div
      :class="[
        border,
        'border rounded-lg overflow-hidden flex flex-row items-center',
      ]"
    >
      <!-- +63 Prefix -->
      <div
        v-if="type === 'mobile'"
        class="text-grey-dark text-sm px-2 border-r font-bold papsi-txt-lh select-none"
      >
        +63
      </div>

      <!-- Input Field -->
      <div class="flex-grow">
        <!-- Date Picker -->
        <input
          v-if="type === 'date'"
          ref="textbox"
          :id="name"
          type="date"
          v-model="val"
          :max="maxDate"
          :disabled="disabled || loading"
          class="w-full p-3 outline-none text-sm border-none"
          @focus="onFocus"
          @blur="onBlur"
        />

        <!-- Regular Input -->
        <input
          v-else
          ref="textbox"
          :id="name"
          :type="currentType"
          v-model="val"
          :maxlength="max_length"
          :disabled="disabled || loading"
          :class="[
            'w-full p-3 outline-none text-sm border-none',
            { uppercase },
          ]"
          autocomplete="off"
          spellcheck="false"
          @input="onInput"
          @focus="onFocus"
          @blur="onBlur"
        />
      </div>

      <!-- Password toggle -->
      <div
        v-if="type === 'password'"
        class="px-2 cursor-pointer"
        @click="togglePassword"
      >
        <img
          :src="visible ? visible_icon : hide_icon"
          class="w-icon h-icon papsi-icon-mt"
        />
      </div>

      <!-- Loading -->
      <img
        v-if="loading"
        src="@/assets/icons/papsi_spinner.svg"
        class="w-icon h-icon papsi-icon-mt mr-2"
      />
    </div>

    <!-- Error -->
    <span v-if="internal_error" class="text-xs text-error">{{
      internal_error
    }}</span>
  </div>
</template>

<script>
export default {
  name: "v-form-text-control",
  props: {
    name: { type: String, required: true },
    type: { type: String, default: "text" },
    placeholder: { type: String, default: "" },
    max_length: { type: Number, default: null },
    value: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    uppercase: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    numeric: { type: Boolean, default: false },
    alphanumeric: { type: Boolean, default: false },
    birthday: { type: Boolean, default: false },
  },
  data() {
    return {
      val: this.modelValue || this.value,
      border: "border-grey",
      visible: false,
      visible_icon: require("@/assets/icons/papsi_password_visible.svg"),
      hide_icon: require("@/assets/icons/papsi_password_invisible.svg"),
      internal_error: null,
    };
  },
  computed: {
    currentType() {
      return this.type === "password" && !this.visible ? "password" : "text";
    },
    maxDate() {
      if (!this.birthday) return null;

      const today = new Date();
      return today.toISOString().split("T")[0];
    },
  },
  watch: {
    val(val) {
      this.$emit("update:modelValue", val);
    },

    modelValue(newVal) {
      this.val = newVal;
    },
  },
  methods: {
    onInput(e) {
      let value = e.target.value;

      if (this.numeric) value = value.replace(/[^0-9]/g, "");
      if (this.alphanumeric) value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (this.type === "mobile")
        value = value.replace(/[^0-9]/g, "").slice(0, 10);

      this.val = value;
    },
    onFocus() {
      this.border = "border-primary";
      this.internal_error = null;
    },
    onBlur() {
      this.border = "border-grey";
      if (this.required && !this.val.trim())
        return this.setError("This field is required.");
      if (this.type === "email" && this.val && !this.isEmailValid(this.val))
        return this.setError("Invalid email address.");
      if (this.type === "mobile" && this.val && !this.isMobileValid(this.val))
        return this.setError("Invalid mobile number.");
      if (this.type === "date" && this.val && !this.isDateValid(this.val))
        return this.setError("Invalid date.");
    },
    togglePassword() {
      this.visible = !this.visible;
      this.$refs.textbox.focus();
    },
    setError(msg) {
      this.internal_error = msg;
      this.border = "border-red-light";
    },
    isEmailValid(v) {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v);
    },
    isMobileValid(v) {
      return /^9\d{9}$/.test(v);
    },
    isDateValid(v) {
      return /^\d{4}-\d{2}-\d{2}$/.test(v);
    },
  },
};
</script>

<style scoped>
.papsi-icon-mt {
  margin-top: 7px;
}
.papsi-txt-lh {
  line-height: 40px;
}
</style>
